<template>
  <div class="info-container">
    <short-description :shortDescription="shortDescription" />
    <!-- Характеристики скрыты от пользователей, но нужны для SEO -->
    <characteristics :show-number="3" is-short :characteristics="characteristics" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Characteristics from './characteristics.vue';
import ShortDescription from '../common/short-description.vue';
import type { ICharacteristics } from '../../models/characteristic';
import type { IShortDescription } from '../../models/short-description';
import { useProductPage } from '../../business/use-product-page';

interface Props {
  characteristics: ICharacteristics;
}

const props = defineProps<Props>();

// Get product page state
const { state } = useProductPage();

const shortDescription = computed((): IShortDescription => {
  const product = state.product;

  if (!product) {
    return {
      text: '',
      upperText: '',
      list: [],
    };
  }

  return {
    text: '',
    upperText: product.shortDescription || '',
    list: (product.attributes || []) as string[],
  };
});
</script>

<style lang="stylus" scoped>
.info-container

  +Media(Mobile, Laptop)
    display none

  // Характеристики скрыты от пользователей, но нужны для SEO
  .characteristics
    display none
</style>
